import { render } from "./SzDesc.vue?vue&type=template&id=39981a10&scoped=true"
import script from "./SzDesc.vue?vue&type=script&lang=ts"
export * from "./SzDesc.vue?vue&type=script&lang=ts"

import "./SzDesc.vue?vue&type=style&index=0&id=39981a10&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-39981a10"

export default script